export default __webpack_public_path__ + "static/media/lifeline.b85a3b18.png";